<template>
  <div>
    <Datepicker
      :language="ja"
      :format="customFormatter"
      @input="updateValue"
      :clearButton=clearButton
      :value=value>
    </Datepicker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ja: ja
    }
  },
  props: {
    clearButton: { type: Boolean },
    value: {
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY/MM/DD');
    },
    updateValue: function(e) {
      this.$emit("input", e);
    }
  }
}
</script>

<style>

</style>
